import { scheme } from '@portkey/utils';
export default function openPageInDiscover(url, version) {
    try {
        window.location.href = scheme.formatScheme({
            action: 'linkDapp',
            version,
            domain: window.location.host,
            custom: {
                url: url || window.location.href,
            },
        });
        const downloadUrl = 'https://portkey.finance/';
        setTimeout(() => {
            const hidden = window.document.hidden ||
                window.document.mozHidden ||
                window.document.msHidden ||
                window.document.webkitHidden;
            if (typeof hidden !== 'undefined' && hidden === true) {
                return;
            }
            window.location.href = downloadUrl;
        }, 2000);
    }
    catch (error) {
        // can‘t open app cannot go into this logic
        console.error(error);
        window.open('https://portkey.finance', '_blank');
    }
}
